"use client";

/**
 * Smart root.
 *
 * Architecture:
 *   www.digirankexpert.com  → marketing site (separate Vercel project,
 *                              `digirankexpertmerketing` — owns the
 *                              top-of-funnel pricing/landing).
 *   app.digirankexpert.com  → this SaaS app (auth + dashboard + tools).
 *
 * Logged-in users   → /seo/dashboard (the original behavior).
 * Logged-out users  → marketing apex on www. We do NOT route them at the
 *                     in-app /pricing route because:
 *                       1. SEO juice belongs on www, not on the app subdomain
 *                       2. The marketing site has the full product story
 *                          (services, products, contact, lead-gen forms)
 *                       3. The in-app /pricing remains as a fallback for
 *                          direct shares but isn't the primary funnel.
 *
 * Implemented client-side because the existing app stores its JWT in
 * localStorage, which isn't reachable from a server component. Renders
 * an instant skeleton during the read so it doesn't flash a blank page.
 */

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { Sparkles } from "lucide-react";

const MARKETING_URL =
  process.env.NEXT_PUBLIC_MARKETING_URL || "https://www.digirankexpert.com";

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const token = localStorage.getItem("access_token");
    if (token) {
      router.replace("/seo/dashboard");
    } else {
      // Hard redirect (cross-origin) to the marketing site.
      window.location.replace(MARKETING_URL);
    }
  }, [router]);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-violet-50 to-emerald-50"
      suppressHydrationWarning
    >
      <div className="flex items-center gap-2 text-violet-700 font-semibold">
        <Sparkles className="h-5 w-5 animate-pulse" />
        DigiRank Expert
      </div>
    </div>
  );
}
